import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

export interface SolicitacaoRedefinicaoSenhaPayload {
  email: string;
}

export interface SolicitacaoRedefinicaoSenhaResponse {
  message?: string;
  Mensagem?: string;
  Sucesso?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SolicitacaoRedefinicaoSenhaService {
  private apiUrl = 'https://localhost:7103/api/EnviarEmail/EnvioDeEmail';

  constructor(private http: HttpClient) { }

  enviarEmailRedefinicaoSenha(email: string): Observable<SolicitacaoRedefinicaoSenhaResponse> {
    const params = new HttpParams().set('emailUsuario', email);
    
    return this.http.post<SolicitacaoRedefinicaoSenhaResponse>(this.apiUrl, null, { params })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('Erro na requisição HTTP:', error);
          console.error('Status:', error.status);
          console.error('Status Text:', error.statusText);
          console.error('Error Body:', error.error);
          
          // Se o status for 200 mas vier como erro, tenta tratar como sucesso
          if (error.status === 200 && error.error) {
            return throwError(() => ({
              ...error,
              error: typeof error.error === 'string' 
                ? { message: error.error } 
                : error.error
            }));
          }
          
          return throwError(() => error);
        })
      );
  }
}

